// Cache belongs to the page lifetime. Entries deduplicate simultaneous consumers, never
// bypass revalidation after the last consumer releases a resource.
export function createResourceCache() {
  const pending = new Map();
  return {
    acquire(key, load) {
      let entry = pending.get(key);
      if (!entry) {
        const controller = new AbortController();
        entry = { controller, owners: 0 };
        entry.promise = Promise.resolve().then(() => load(controller.signal));
        pending.set(key, entry);
      }
      entry.owners += 1;
      return { promise: entry.promise, release() {
        entry.owners -= 1;
        if (!entry.owners && pending.get(key) === entry) {
          entry.controller.abort(); pending.delete(key);
        }
      } };
    },
  };
}
